function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 9.5,
  fill: "#262f39",
  r: 4.5
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 9.5,
  r: 8.5,
  stroke: "#262f39",
  strokeDasharray: "1 2",
  strokeLinecap: "round"
});
function SvgAltProgressComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 19 19",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltProgressComplete);
export default __webpack_public_path__ + "static/media/alt-progress-complete.7f3e33ff29d5c843192064b1b090783b.svg";
export { ForwardRef as ReactComponent };